// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploadNavBar {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: #1faeff;
    top: 0;
    left: 0;
    width: 100vw;
    height: 75px;
    z-index: 1;
}

.uploadNavBar .titleText.small {
    color: #fff;
    cursor: pointer;
}

#Upload {
    padding: 20px 0;
    padding-top: calc(75px + 20px);
    align-items: flex-start;
}

#UploadLayout {
    align-items: flex-start !important;
}

#UploadLayout h1 {
    margin-left: 0;
}

#UploadLayout input,
#UploadLayout textarea {
    width: 500px;
}

#UploadLayout .ASRInput {
    display: flex;
    margin-left: 40px;
}

#UploadLayout .ASRInput>* {
    margin: 0 5px;
}

#UploadLayout .labelledInputContainer,
#UploadLayout .fileInput {
    margin-left: 20px;
}

.StudioDetails .labelledInputContainer {
    width: 100%;
}

#UploadLayout .dropDown {
    margin-left: 5px;
}

#UploadLayout>* {
    margin: 5px 0;
}

@keyframes loader {
    0% {
        clip-path: polygon(0 100%, 100% 100%, 100% 100%, 0 100%);
    }

    75% {
        clip-path: polygon(0 100%, 100% 100%, 100% 0%, 0 0%);
        opacity: 1;
    }

    100% {
        clip-path: polygon(0 100%, 100% 100%, 100% 0%, 0 0%);
        opacity: 0;
    }
}

.status {
    display: flex;
    align-items: center;
}

.status img {
    width: 30px;
    height: 30px;
    margin-right: 5px;
}

.status img.upload {
    animation: loader 2s infinite forwards;
}

.transcriptInputContainer {
    display: flex;
    align-items: center;
}

.transcriptInputContainer label {
    margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/Magor/Upload/upload.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,wDAAwD;IAC5D;;IAEA;QACI,oDAAoD;QACpD,UAAU;IACd;;IAEA;QACI,oDAAoD;QACpD,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".uploadNavBar {\n    position: fixed;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    background: #1faeff;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 75px;\n    z-index: 1;\n}\n\n.uploadNavBar .titleText.small {\n    color: #fff;\n    cursor: pointer;\n}\n\n#Upload {\n    padding: 20px 0;\n    padding-top: calc(75px + 20px);\n    align-items: flex-start;\n}\n\n#UploadLayout {\n    align-items: flex-start !important;\n}\n\n#UploadLayout h1 {\n    margin-left: 0;\n}\n\n#UploadLayout input,\n#UploadLayout textarea {\n    width: 500px;\n}\n\n#UploadLayout .ASRInput {\n    display: flex;\n    margin-left: 40px;\n}\n\n#UploadLayout .ASRInput>* {\n    margin: 0 5px;\n}\n\n#UploadLayout .labelledInputContainer,\n#UploadLayout .fileInput {\n    margin-left: 20px;\n}\n\n.StudioDetails .labelledInputContainer {\n    width: 100%;\n}\n\n#UploadLayout .dropDown {\n    margin-left: 5px;\n}\n\n#UploadLayout>* {\n    margin: 5px 0;\n}\n\n@keyframes loader {\n    0% {\n        clip-path: polygon(0 100%, 100% 100%, 100% 100%, 0 100%);\n    }\n\n    75% {\n        clip-path: polygon(0 100%, 100% 100%, 100% 0%, 0 0%);\n        opacity: 1;\n    }\n\n    100% {\n        clip-path: polygon(0 100%, 100% 100%, 100% 0%, 0 0%);\n        opacity: 0;\n    }\n}\n\n.status {\n    display: flex;\n    align-items: center;\n}\n\n.status img {\n    width: 30px;\n    height: 30px;\n    margin-right: 5px;\n}\n\n.status img.upload {\n    animation: loader 2s infinite forwards;\n}\n\n.transcriptInputContainer {\n    display: flex;\n    align-items: center;\n}\n\n.transcriptInputContainer label {\n    margin-right: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
